import { TOGGLE_NAVBAR, TOGGLE_NAVBAR_DROPDOWN } from './actionTypes';
export var showNavbar = function (name) { return ({
    type: TOGGLE_NAVBAR,
    name: name
}); };
export var hideNavbar = function () { return ({
    type: TOGGLE_NAVBAR
}); };
export var showNavbarDropdown = function (name) { return ({
    type: TOGGLE_NAVBAR_DROPDOWN,
    name: name
}); };
export var hideNavbarDropdown = function () { return ({
    type: TOGGLE_NAVBAR_DROPDOWN
}); };
